var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function () { };
export function BaseTransition(_a) {
    var enter = _a.in, _b = _a.onExit, onExit = _b === void 0 ? noop : _b, _c = _a.onExited, onExited = _c === void 0 ? noop : _c, children = _a.children, rest = __rest(_a, ["in", "onExit", "onExited", "children"]);
    // 离场时保持 children 不变
    var childrenRef = useRef(null);
    return (React.createElement(CSSTransition, __assign({ mountOnEnter: true, unmountOnExit: true }, rest, { in: enter, onExit: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            childrenRef.current = children;
            onExit.apply(void 0, args);
        }, onExited: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            childrenRef.current = null;
            onExited.apply(void 0, args);
        } }), childrenRef.current || children));
}
